var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('img',{staticClass:"img",attrs:{"src":require("@/assets/logo.png")}}),_c('HelloWorldVue',{attrs:{"msg":'Welcome to Your Vue.js App'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }